import { makeStyles } from '@material-ui/core';

import { neutral, teal } from 'shared/styles/colors';

export default makeStyles(() => ({
  root: {
    color: neutral.D15,
  },
  iconRoot: {
    width: '2rem',
    height: '2rem',
    color: teal.D5,
  },
}));
